// extracted by mini-css-extract-plugin
module.exports =  {"tab":"GameTab__tab--vr","game":"GameTab__game--Is","narrow":"GameTab__narrow--jt"};